import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/fr/og-en.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__fr-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

const QAPageJsonld = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  breadcrumb: 'Lemonade.com > Lemonade FAQ',
  name: 'Lemonade FAQ',
  image:
    'https://www.lemonade.com/assets/lemonade-share-image-ad9d7846f31685bfb4af89f018e4dd5d460f4e73768a8fd500bfc1f069ff853a.png',
  description:
    "Vous trouverez les réponses aux questions les plus fréquentes - de ce qu'est l'assurance responsabilité civile à ce que couvre votre assurance habitation.",
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['fr-FR'].layout },
  seo: {
    title: 'Assurance Multirisques Habitation FAQ | Lemonade à partir de 4 €/mois',
    metaTitle: 'Assurance Multirisques Habitation FAQ | Lemonade à partir de 4 €/mois',
    description:
      "Vous trouverez les réponses aux questions les plus fréquentes - de ce qu'est l'assurance responsabilité civile à ce que couvre votre assurance habitation.",
    jsonld: [QAPageJsonld],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
